<template>
  <div :class="showBackgroundColor ? 'footer font12 bc' : 'footer font12'">
    日浩版权所有 ©

    <span style="font-family: Arial">2005-{{ year }} </span>
  </div>
</template>

<script>
export default {
  name: "FooterM",
  props: {
    showBackgroundColor: Boolean,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped lang="less">
.footer {
  display: block;
  width: 100vw;
  text-align: center;
  color: #000;
  line-height: 0.4rem;
  box-sizing: border-box;
  // background-color: #fff;
}
.bc {
  color: #fff;

  background-color: #6ebc36;
}
.hand {
  width: 15px;
  margin-right: 5px;
}
</style>
